module.exports = __webpack_public_path__ + "img/Q-bee-faq.3a1fd83e.svg";